let BASE_URL = 'https://www.froogal.in/dedicated-api/';

const URLS = {
    device: 'device/init',
    loyalty: 'loyalty/v2',
    config: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/config',
    loyaltyConfig: 'config',
    cards: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/cards',
    userDetails: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/user/details',
    pointsHistory: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/user/points-history',
    expiredBenefits: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/user/freebies/history',
    activeBenefits: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/user/freebies/live',
    nextCardStatus: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/next-card-status',
    getCardFreebies: (loyaltyId, loyaltyCardId) => 'loyalty/v2/' + loyaltyId + '/cards/' + loyaltyCardId + '/freebies/base',
    buyLoyaltyCard: (loyaltyId, upgardeCardId) => 'loyalty/v2/' + loyaltyId + '/cards/' + upgardeCardId + '/buy',
    getExclusiveFreebies: (loyaltyId, loyaltyCardId) => 'loyalty/v2/' + loyaltyId + '/cards/' + loyaltyCardId + '/freebies/exclusive',
    redeemFreebie: (loyaltyId, loyaltyCardId, freebieId) => 'loyalty/v2/' + loyaltyId + '/cards/' + loyaltyCardId + '/freebies/base/' + freebieId + '/buy',
    getPrograms: (loyaltyId) => 'loyalty/v2/' + loyaltyId + '/programs',
    enrollmentCriteria: (loyaltyId, loyaltyCardId) => 'loyalty/v2/' + loyaltyId + '/cards/' + loyaltyCardId + '/enrollment-criteria',
    loyaltySignUp: (loyaltyId, loyaltyCardId) => 'loyalty/v2/' + loyaltyId + '/cards/' + loyaltyCardId + '/signup',
    requestOtp: "auth/login/otp/request",
    validateOtp: "auth/login/otp/validate",
    shopifySignUp: "shopify/signup",
    getProfile: 'profile',
    getPoints: 'loyalty/points',
    getCoupons: 'loyalty/coupons/list',
    getFreebies: 'loyalty/my-freebie/list',
    postApplyCoupon: 'loyalty/coupon/redeem',
    postApplyPoints: 'loyalty/points/redeem',
    postApplyFreebie: 'loyalty/freebie/redeem',
    getUser: 'user',
    paymentModes: 'payment/payment-modes',
    getSavedCards: 'payment/saved-cards',
    deleteCard: 'payment/delete-card',
    validateVPA: 'payment/validate-vpa',
    updateProfile: 'profile/update',
    themeConfig: 'content',
};

const apiClient = {
    Urls: URLS,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },

    setBaseUrl(baseUrl) {
        if (baseUrl[baseUrl.length - 1] !== '/') {
            baseUrl = baseUrl + '/';
        }
        BASE_URL = baseUrl;
    },

    make(url, method, params = {}) {
        params.merchantAccessToken = params.merchantAccessToken || window.merchantAccessToken;
        if (url.indexOf('http') != 0) {
            url = BASE_URL + url;
        }

        let reqUrl = method === 'GET' ? `${url}?${new URLSearchParams(params).toString()}` : url;
        return fetch(reqUrl, {
            method,
            headers: apiClient.headers,
            ...(method === 'GET' ? {} : { body: JSON.stringify(params) }),
        }).then(response => response.json());
    },

    post(url, params) {
        return this.make(url, 'POST', params);
    },

    get(url, params) {
        return this.make(url, 'GET', params);
    },

}

export default apiClient;
